import { render, staticRenderFns } from "./PropertySearchTable.vue?vue&type=template&id=23f195ec"
import script from "./PropertySearchTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertySearchTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports